import { useParams, useLocation, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import { fetchStudentVideoStreamUrl, fetchStudentVideoUploads } from '../api';
import DownloadVideoButton from './DownloadVideoButton';

const WatchRecording = () => {
    const { studentUsername, filename } = useParams();
    const location = useLocation();
    const [streamUrl, setStreamUrl] = useState(null);
    const [videoKey, setVideoKey] = useState(location.state?.key ?? null);
    const [error, setError] = useState(null);
    const stateKey = location.state?.key;

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                // Prefer the key passed via Link state
                // Fall back to looking it up by filename so a direct refresh of this URL still works
                let key = stateKey;
                if (!key) {
                    const recording = await fetchStudentVideoUploads(studentUsername);
                    const match = recording.find(u => u.key.endsWith(`/${filename}`));
                    if (!match) {
                        if (!cancelled) setError('Recording not found.');
                        return;
                    }
                    key = match.key;
                }
                if (!cancelled) setVideoKey(key);
                const url = await fetchStudentVideoStreamUrl(studentUsername, key);
                if (!cancelled) setStreamUrl(url);
            } catch (err) {
                console.error(err);
                if (!cancelled) setError('Failed to load recording.');
            }
        };
        load();
        return () => { cancelled = true; };
    }, [studentUsername, filename, stateKey]);

    return (
        <Box sx={{ p: { xs: 1, sm: 2 }}}>
            <Link to={`/admin/${encodeURIComponent(studentUsername)}/recordings`} style={{ color: '#4447ad' }}>
                &larr; Back to recordings
            </Link>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2, mb: 2 }}>
                <Typography sx={{
                    fontSize: { xs: '0.75rem', sm: '1.25rem' },
                    minWidth: 0,
                    overflowWrap: 'anywhere',
                }}>{filename}</Typography>
                {videoKey && (
                    <Box>
                        <DownloadVideoButton
                            studentUsername={studentUsername}
                            videoKey={videoKey}
                            onError={setError}
                        />
                    </Box>
                )}
            </Box>
            {error && <Alert severity="error" sx={{ maxWidth: 500, mx: 'auto' }}>{error}</Alert>}
            {streamUrl && (
                <video
                    controls
                    src={streamUrl}
                    style={{ width: '100%', maxWidth: 960, background: '#000' }}
                />
            )}
        </Box>
    );
};

export default WatchRecording;
